import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Image, Button } from "react-bootstrap";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../../vendorDashboardComponents/navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../vendorDashboardComponents/navigationSection/BottomNavigationMobile";
import { TopNavigationBarMobile } from "../../../../vendorDashboardComponents/navigationSection/TopNavigationBarMobile";
import AddWalkInWait from "./AdminAddWalkInWait";
import AddReservation from "./AdminAddReservation";
import store from "../../../../../store/store";
import { SET_VENDOR_INFORMATION } from "../../../../../store/types";
import { withRouter } from "react-router-dom";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

const AdminAddDiner = () => {
  const [selectedPage, setSelectedPage] = useState(1);
  const onPageChange = (value) => (e) => {
    setSelectedPage(value);
  };
  const location = useLocation();
  const [allData, setAllData] = useState({});

  useEffect(function effectFunction() {
    if (location.state.data !== null && location.state.data !== undefined) {
      setAllData(location.state.data);
    }
  }, []);
  store.dispatch({
    type: SET_VENDOR_INFORMATION,
    payload: allData,
  });

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel p-0">
            {/* <RightSideNavigation /> */}
            <HomeReusableTopBarNavigation displayText="All Active Vendors" />
            <div className="pl-4 pr-4 pt-4">
              <div className="f24_700_HelveticaNeue pb-4">Add Diner</div>
              <div className="d-flex align-items-start">
                <Button
                  variant="link"
                  className={`enAddOffersOPtion d-flex flex-column align-items-center mr-5 ${
                    selectedPage === 1 ? "active" : ""
                  }`}
                  onClick={onPageChange(1)}
                >
                  <Image
                    src={
                      selectedPage === 1
                        ? require("../../../../../assets/images/ActionImages/1/walkActive.svg")
                        : require("../../../../../assets/images/ActionImages/1/walk.svg")
                    }
                    alt="View"
                    title="View"
                    fluid
                  />
                  <span className="active f12-400 d-block w-100 mb-2">
                    Walk-in/Wait
                  </span>
                </Button>
                <Button
                  variant="link"
                  className={`enAddOffersOPtion d-flex flex-column align-items-center ml-3 ${
                    selectedPage === 2 ? "active" : ""
                  }`}
                  onClick={onPageChange(2)}
                >
                  <Image
                    src={
                      selectedPage === 2
                        ? require("../../../../../assets/images/ActionImages/1/ReservationsActive.svg")
                        : require("../../../../../assets/images/ActionImages/1/Reservations.svg")
                    }
                    alt="View"
                    title="View"
                    fluid
                  />
                  <span className="active f12-400 d-block w-100 mb-2">
                    Reservations
                  </span>
                </Button>
              </div>
              <hr />
              {selectedPage === 1 && <AddWalkInWait />}
              {selectedPage === 2 && <AddReservation />}
            </div>
          </div>
          <div className="bottom-panel">
            <BottomNavigationMobile />
          </div>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default withRouter(AdminAddDiner);
